import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from "@angular/core";
import { SvgIconComponent } from "angular-svg-icon";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-button-list-single-select",
  templateUrl: "./button-list-single-select.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./button-list-single-select.component.scss"],
  imports: [SvgIconComponent, TranslateModule]
})
export class ButtonListSingleSelectComponent implements OnInit {
  @Input() icon: string;
  @Input() placeholderPath?: string;
  @Input() selectedElementPath?: string;

  @Output() clicked: EventEmitter<void> = new EventEmitter<void>();

  public onClicked(): void {
    this.clicked.emit();
  }

  constructor() {}

  ngOnInit(): void {}
}
